'use client'

import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from 'react'
import { cx } from './utils/cx'
import { useAccent } from './AccentContext'

type ToastFn = (msg: string) => void

const ToastContext = createContext<ToastFn | null>(null)

export function ToastProvider({ children, proofing }: { children: ReactNode; proofing?: boolean }) {
  const [msg, setMsg] = useState('')
  const [on, setOn] = useState(false)
  const tRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)
  const { v } = useAccent()

  const show = useCallback<ToastFn>((m) => {
    setMsg(m)
    setOn(true)
    clearTimeout(tRef.current)
    tRef.current = setTimeout(() => setOn(false), 1600)
  }, [])

  return (
    <ToastContext.Provider value={show}>
      {children}
      <div className={cx('st-toast', on && 'on', proofing && 'proofing')}>
        <span className="accent-bit" style={{ color: `var(${v})` }}>
          ●
        </span>
        <span>{msg}</span>
      </div>
    </ToastContext.Provider>
  )
}

export function useToast(): ToastFn {
  const fn = useContext(ToastContext)
  if (!fn) return () => {}
  return fn
}
